import React, { useMemo, useState } from 'react';
import { IconCardBenefit, IconOffersMobile, IconEntertainment, IconCalendar } from '@americanexpress/dls-icons';
import { FormattedMessage } from 'react-intl';
import styles from './styles/PrivacyFlow.scss';
const IconHoverList = () => {
  const [hoveredIcon, setHoveredIcon] = useState(null);
  const preferenceUpdateItems = useMemo(() => [{
    icon: IconCardBenefit,
    title: 'Card Benefits',
    messageId: 'privacy.cardBenfit'
  }, {
    icon: IconOffersMobile,
    title: 'offers-mobile',
    messageId: 'privacy.offersMobile'
  }, {
    icon: IconEntertainment,
    title: 'entertainment',
    messageId: 'privacy.entertainment'
  }, {
    icon: IconCalendar,
    title: 'calendar',
    messageId: 'privacy.calendar'
  }], []);
  return preferenceUpdateItems.map(item => /*#__PURE__*/React.createElement("div", {
    key: item.messageId,
    className: styles.preferenceUpdates
  }, /*#__PURE__*/React.createElement("span", {
    onMouseEnter: () => setHoveredIcon(item.messageId),
    onMouseLeave: () => setHoveredIcon(null)
  }, /*#__PURE__*/React.createElement(item.icon, {
    size: "xl",
    title: item.title,
    color: "brand",
    isFilled: hoveredIcon === item.messageId
  })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: item.messageId
  }))));
};
export default IconHoverList;